'use client';

import * as React from 'react';

import { cn } from '@playbooks/ui/lib/utils';

function Label({ className, ...props }: React.ComponentProps<'label'>) {
	// Theme
	const rootClassName = cn(
		'flex items-center gap-2 text-sm leading-none font-medium text-foreground-body select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50',
		className,
	);

	// Render
	return <label data-slot='label' className={rootClassName} {...props} />;
}

export { Label };
